import { architeckCall } from 'database';
import keys from 'keys';
import React from "react";
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

const required_form_fields = [
    'type',
    'error_message',
    'time_of_error',
    'description',
]

class ReportBug extends React.Component {

    state = {
        bug: {
            user: this.props.viewing_user._id,
            project: this.props.project._id,
            company: this.props.project.company._id,
        },
        canSave: true
    }


    onSave = async () => {

        this.setState({canSave: false})
        //copy state
        let newState = Object.assign({}, this.state.bug);
        //assume we have no errors
        let errors = 0;

        required_form_fields.forEach((field) => {
            //check each required field
            if(newState[field]) {
                newState[field + "State"] = 'valid'; 
            } else {
                newState[field + "State"] = 'invalid'; 
                errors++
            }

        })

        this.setState({ bug: newState });

        if(!errors) { 

            const created = await architeckCall({
                method: 'post',
                url: '/api/v1/crud/bugs/create',
                data: newState,
            });

            //reset bug
            this.setState({bug: {
                user: this.props.viewing_user._id,
                project: this.props.project._id,
                company: this.props.project.company._id,
            }})

            if(created.success) {

                const url = window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://master.architeck.io'

                const email = await architeckCall({
                    method: 'POST',
                    url: '/api/v1/integrations/sengrid/branded',
                    data: {
                        "to": "john@architeck.io",
                        "from": "webmaster@architeck.io",
                        "subject": `New Bug Was Reported On Project ${this.props.project.name}`,
                        "title": "A Bug Was Found",
                        "body": `Details about a bug being found on project "${this.props.project.name}" have been created. You may view the ticket through your secured <a href='${url}/admin/projects/view/${this.props.project._id}'>dashboard portal here</a> `
                    }
                }) 
        
                if(email.success) {

                    //send success alert
                    toggleAlert(true, 'success', 'Your bug has been submitted.', '4000' )

                } else {

                    //send failure alert
                    console.log(email)
                    toggleAlert(true, 'danger', 'System error, please send details of your bug request to john@architeck.io', 'infinite' )

                }
            
            } else {

                //send failure alert
                console.log(created)
                toggleAlert(true, 'danger', 'System error, please send details of your bug request to john@architeck.io', 'infinite' )

            }


        }

        //after load make sure button work again
        this.setState({canSave: true})

    }

    onInputChange = (e, stateName) => {

        let newState = Object.assign({}, this.state.bug);
        newState[stateName] = e.target.value;

        if (stateName === "checkbox") {
          if (e.target.value) {
            newState.checkboxState = "valid";
          } else {
            newState.checkboxState = "invalid";
          }
        } else {
          if (e.target.value === "") {
            newState[stateName + "State"] = "invalid";
          } else {
            newState[stateName + "State"] = "valid";
          }
        }

        this.setState({ bug: newState });
    };

    render() {

        return (
            <Card>

                {this.state.alert}

                <CardHeader>
                    <Row className="align-items-center">
                        <Col xs="8">
                            <h3 className="mb-0">Whoops! Something Went Wrong</h3>
                        </Col>
                    </Row>
                </CardHeader>

                <CardBody>

                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="type" > 
                                    The type of error was: 
                                </label>
                                <Input
                                    id="type"
                                    value={this.state.bug.type || ''}
                                    type="select"
                                    valid={ this.state.bug.typeState === "valid" }
                                    invalid={ this.state.bug.typeState === "invalid" }
                                    onChange={e => this.onInputChange(e, "type") }
                                >
                                    <option>Select One</option>
                                    <option value="Something Did Not Update Or Create As Expected">Something Did Not Update Or Create As Expected</option>
                                    <option value="Page Or Website Did Not Load">Page Or Website Did Not Load</option>
                                    <option value="Design Is Off">Design Is Off</option>
                                    <option value="Something Is Broken">Something Seems Broken</option>
                                    <option value="Other">Other</option>
                                </Input>
                                <div className="valid-feedback">Looks good!</div>
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="error_message" > 
                                    The error message given was:
                                </label>
                                <Input
                                    id="error_message"
                                    value={this.state.bug.error_message || ''}
                                    placeholder="Code 1, Something Failed, None"
                                    type="text"
                                    valid={ this.state.bug.error_messageState === "valid" }
                                    invalid={ this.state.bug.error_messageState === "invalid" }
                                    onChange={e => this.onInputChange(e, "error_message") }
                               />
                                <div className="valid-feedback">Looks good!</div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="time_of_error" > 
                                    This happened around: 
                                </label>
                                <Input
                                    id="time_of_error"
                                    value={this.state.bug.time_of_error || ''}
                                    placeholder="10/10/2019 in the evening"
                                    time_of_error="text"
                                    valid={ this.state.bug.time_of_errorState === "valid" }
                                    invalid={ this.state.bug.time_of_errorState === "invalid" }
                                    onChange={e => this.onInputChange(e, "time_of_error") }
                                />
                                <div className="valid-feedback">Looks good!</div>
                            </FormGroup>
                        </Col>

                    </Row>

                    <FormGroup>
                        <label className="form-control-label" htmlFor="description" > 
                            The best way I can describe this error is:
                        </label>
                        <Input
                            style={{minHeight: 300}}
                            id="description"
                            value={this.state.bug.description || ''}
                            placeholder="After I clicked on... this happened..."
                            type="textarea"
                            valid={ this.state.bug.descriptionState === "valid" }
                            invalid={ this.state.bug.descriptionState === "invalid" }
                            onChange={e => this.onInputChange(e, "description") }
                        />
                        <div className="valid-feedback">Looks good!</div>
                    </FormGroup>

                    <div className="mt-3 text-right">
                        <Button onClick={this.onSave} className="btn btn-success">Submit</Button>
                    </div>
            
                </CardBody>
            </Card>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
  
    };
};
  
export default connect(mapStateToProps, '')(ReportBug);